import './orgPackList.css';
import OrgTripStrap from '../../components/orgTripStrap/OrgTripStrap';
import { useCallback, useEffect, useState } from 'react';
import ReactLoading from 'react-loading';
import errorHandle from '../../utils/errorHandle';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { countOfPackages, FetchPackList } from './orgPackListFun/fetchPackList';
import EmptyPage from '../../components/empty-page/emptyPage';
import Pagination from '../../components/pagination/Pagination';
import SearchIcon from '../../assets/icons/trvto_searchIconActive.svg';

export default function OrgPackList() {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const selectedStatus = searchParams.get('status') || 'active';
    const datesType = searchParams.get('datesType') || 'fixed';
    const group = searchParams.get('group') || 'backpacking';
    const pageNumber = Number(searchParams.get('page')) || 1;
    const [searchRe, setSearchRe] = useState('');
    const [debouncedSearch, setDebouncedSearch] = useState('');
    const [loading, setLoading] = useState(false);
    const [nav, setNav] = useState(false);
    const [tripData, setTripData] = useState([]);
    const [selectedPack, setSelectedPack] = useState('');
    const limit = 10;
    const [totalCount, setTotalCount] = useState(0);
    const offSet = (pageNumber - 1) * limit;
    const totalData = totalCount;
    const totalPages = Math.ceil(totalData / limit);

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }, []);

    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedSearch(searchRe.trim());
        }, 500); // 500ms delay

        return () => clearTimeout(timer);
    }, [searchRe]);

    const updateURL = useCallback(
        (params) => {
            const current = Object.fromEntries([...searchParams]);

            Object.keys(params).forEach((key) => {
                if (params[key] === '' || params[key] === null) {
                    delete current[key];
                } else {
                    current[key] = params[key];
                }
            });
            setSearchParams(current);
        },
        [searchParams, setSearchParams]
    );

    useEffect(() => {
        if (!totalPages) return;

        if (pageNumber > totalPages) {
            updateURL({ page: totalPages });
        }
        //eslint-disable-next-line
    }, [totalPages, pageNumber, updateURL]);

    const paginationClick = (number, offSetNumber) => {
        if (Math.ceil(totalData / limit) > 1) {
            updateURL({ page: number });
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    };

    useEffect(() => {
        async function fetchPackList() {
            setLoading(true);
            try {
                await FetchPackList(
                    setTripData,
                    selectedStatus,
                    limit,
                    offSet,
                    datesType,
                    group,
                    setLoading,
                    debouncedSearch
                );
            } catch (error) {
                setLoading(false);
                errorHandle(error);
            }
        }
        fetchPackList();
    }, [selectedStatus, limit, offSet, datesType, group, debouncedSearch]);

    useEffect(() => {
        countOfPackages(setTotalCount, selectedStatus, datesType, group, setLoading, debouncedSearch);
    }, [selectedStatus, datesType, group, debouncedSearch]);

    if (nav && selectedPack) {
        window.open(`/org/trip/details/${selectedPack}`, '_blank');
    }

    return (
        <div>
            {loading && (
                <div className='loadingBackground'>
                    <ReactLoading type='spin' color='#006aff' className='loadingSpin' />
                </div>
            )}
            <div className='orgPack'>
                {/* discuss on whether we need filters in mybooking */}
                {/* <Filters filterData={filterDummy?.data} /> */}
                {/* <Filters filterData={[]} /> */}
                <div className='orgPackTripStrap'>
                    <div className='orgPackHeadSeaDiv alignCenter'>
                        <h1 className='orgBookingHeading'>My Packages</h1>
                        {/* <div className="orgPackSearchDiv">
                            <input
                                placeholder="Search your packages"
                                name="orgSearch"
                                value={searchText}
                                className="orgPackSearch"
                                onChange={(sea) =>
                                    handleTextChange(sea, setSearchText)
                                }
                            />
                            <button
                                type="button"
                                onClick={() =>
                                    orgPackSearch(searchText, setSearchRe)
                                }
                                className="orgPackSearchBtn"
                            >
                                Search
                            </button>
                        </div> */}
                        <div className='orgPackFilters'>
                            <div className='search-input'>
                                <img src={SearchIcon} alt='searchIcon' className='search-icon' />
                                <input
                                    placeholder='Search your packages'
                                    name='orgSearch'
                                    value={searchRe}
                                    className='select mr-2 searchBarInput'
                                    onChange={(e) => setSearchRe(e.target.value)}
                                />
                            </div>
                            <select
                                name='date'
                                id='date'
                                className='select'
                                onChange={(e) => {
                                    updateURL({ status: e.target.value, page: 1 });
                                }}
                                value={selectedStatus}
                            >
                                <option value='active'>Approved</option>
                                <option value='inactive'>Not Approved</option>
                                <option value='rejected'>Rejected</option>
                            </select>
                            <select
                                name='datesType'
                                id='datesType'
                                className='select'
                                onChange={(e) => {
                                    updateURL({ datesType: e.target.value, page: 1 });
                                }}
                                value={datesType}
                            >
                                <option value='fixed'>Fixed</option>
                                <option value='custom'>Custom</option>
                            </select>
                            <select
                                name='group'
                                id='group'
                                className='select'
                                onChange={(e) => {
                                    updateURL({ group: e.target.value, page: 1 });
                                }}
                                value={group}
                            >
                                <option value='backpacking'>Backpacking</option>
                                <option value='vehicle'>Vehicle</option>
                            </select>
                            <button className='orgPackCreateBtn blueBtn' onClick={() => navigate('/org/create/pack')}>
                                Create {window.innerWidth < 768 ? '' : 'Package'}
                            </button>
                        </div>
                    </div>

                    {tripData?.length === 0 && !loading ? (
                        <EmptyPage />
                    ) : (
                        <>
                            <OrgTripStrap
                                page={'orgPackList'}
                                setNav={setNav}
                                data={tripData}
                                setSelectedPack={setSelectedPack}
                                selectedStatus={selectedStatus}
                            />
                            <Pagination
                                paginationClick={paginationClick}
                                numberOfRows={totalData}
                                offSet={offSet}
                                pageNumber={pageNumber}
                                limit={limit}
                            />
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}
